import Vue from "vue";

export function showError(message = "Something went wrong", title = "Error") {
    Vue.notify({
        title: title,
        text: message,
        type: "error",
    });
}

export function showSuccess(message = "ok", title = "Success") {
    Vue.notify({
        title: title,
        text: message,
        type: "success"
    });
}
